/* eslint-disable react-hooks/rules-of-hooks */
import { decodeToken } from 'react-jwt';
 
import axiosServices from '../../utils/axios';
const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  } 
  const decoded = decodeToken(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

const setSession = (accessToken,mail,nameSurname,idCcnUser) => {
  if (accessToken) { 
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('mail', mail);
    localStorage.setItem('nameSurname', nameSurname);
    localStorage.setItem('idCcnUser', idCcnUser);
    localStorage.setItem('auth', true);
    axiosServices.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('mail');
    localStorage.removeItem('nameSurname');
    localStorage.removeItem('idCcnUser'); 
    localStorage.removeItem('auth', false);
    delete axiosServices.defaults.headers.common.Authorization; 
  }
};
 
const sign = (payload, privateKey, header) => {
  const now = new Date();
  header.expiresIn = new Date(now.getTime() + header.expiresIn);
  const encodedHeader = btoa(JSON.stringify(header));
  const encodedPayload = btoa(JSON.stringify(payload));
  const signature = btoa(
    Array.from(encodedPayload)
      .map((item, key) =>
        String.fromCharCode(item.charCodeAt(0) ^ privateKey[key % privateKey.length].charCodeAt(0)),
      )
      .join(''),
  );

  return `${encodedHeader}.${encodedPayload}.${signature}`;
};

const verify = (token, privateKey) => {
  const [encodedHeader, encodedPayload, signature] = token.split('.');
  const header = JSON.parse(atob(encodedHeader));
  const payload = JSON.parse(atob(encodedPayload));
  const now = new Date();

  if (now < header.expiresIn) {
    throw new Error('Expired token');
  }

  const verifiedSignature = btoa(
    Array.from(encodedPayload)
      .map((item, key) =>
        String.fromCharCode(item.charCodeAt(0) ^ privateKey[key % privateKey.length].charCodeAt(0)),
      )
      .join(''),
  );

  if (verifiedSignature !== signature) {
    throw new Error('Invalid signature');
  }

  return payload;
};

export { isValidToken, setSession, sign, verify };
